import type { FC } from 'react';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import { KidDocumentsLegacy } from './documents-legacy/KidDocuments';
import { ProductGovernanceDocumentsLegacy } from './documents-legacy/ProductGovernanceDocuments';
import { TermsheetDocumentsLegacy } from './documents-legacy/TermsheetDocuments';

export interface AllDocumentsLegacyProps {
  className?: string;
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export const AllDocumentsLegacy: FC<AllDocumentsLegacyProps> = ({ tabId, workspaceType }) => (
  <>
    <KidDocumentsLegacy tabId={tabId} workspaceType={workspaceType} />
    <TermsheetDocumentsLegacy tabId={tabId} workspaceType={workspaceType} />
    <ProductGovernanceDocumentsLegacy tabId={tabId} workspaceType={workspaceType} />
  </>
);
